import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const MiddleYoungOnboardingTutorialEasy = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClickAtras = () => {
    const currentParams = location.search;
    navigate(`/sport-login-MIDDLEYOUNG-mobile${currentParams}`);
  };

  const handleButtonAdelante = () => {
    const currentParams = location.search;
    navigate(`/sport-onboarding_steppper-MIDDLEYOUNG-mobile${currentParams}`);
  };

  return (
      <div className="young-onboarding-screen-easy">
        <div className="young-onboarding-2">
          <div className="overlap-group-2">
            {/* <div className="content-wrapper">
            <div className="content-3">
              <div className="text-wrapper-6">9:50</div>

              <img className="img" alt="Icons" src="/img/icons-6.svg" />
            </div>
          </div> */}

            <img
                className="rectangle-2"
                alt="Rectangle"
                src="/img/rectangle.png"
            />

            <img className="group" alt="Group" src="/img/tutorialmyoung.png" />
          </div>

          <p className="pay-for-your-favorit">
            All you need in your phone. <br />
            We offer the best user experience to make your tasks easier.
          </p>

          <div className="payment-worldwide">Easy and Complete</div>
          <div
              className="frame-3 highlighted-button"
              onClick={handleButtonAdelante}
          >
            <img
                alt="Frame"
                width={25}
                style={{ marginTop: 15, marginLeft: 10 }}
                src="/img/flecha-adelante-azul.png"
            />
          </div>

          {/* <div className="img-slider-dots">
          <SliderDots className="slider-dots-instance" status="off" />
          <SliderDots className="design-component-instance-node" status="on" />
          <div className="ellipse" />
        </div> */}

          <div
              className="frame-4 highlighted-button"
              onClick={handleButtonClickAtras}
          >
            <img
                alt="Frame"
                width={25}
                style={{ marginTop: 15, marginLeft: 10 }}
                src="/img/flecha-atras-azul.png"
            />
          </div>
        </div>
      </div>
  );
};
